import { render, staticRenderFns } from "./AssetReviewStepCustomQuestions.vue?vue&type=template&id=8c5bb36e&"
import script from "./AssetReviewStepCustomQuestions.vue?vue&type=script&lang=js&"
export * from "./AssetReviewStepCustomQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AssetReviewStepCustomQuestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c5bb36e')) {
      api.createRecord('8c5bb36e', component.options)
    } else {
      api.reload('8c5bb36e', component.options)
    }
    module.hot.accept("./AssetReviewStepCustomQuestions.vue?vue&type=template&id=8c5bb36e&", function () {
      api.rerender('8c5bb36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/AssetReview/ReviewSteps/AssetReviewStepCustomQuestions.vue"
export default component.exports